import React, {useEffect, useMemo, useRef, useState} from 'react';
import {common} from '../../../common/common';
import {PostInterface} from '../../../interface/post.interface';
import ReactQuill, {Quill} from 'react-quill';
import 'react-quill/dist/quill.bubble.css';
import QuillImageDropAndPaste from '../../quillEditor/ImageDropAndPaste';
import {Box, Tooltip, Typography} from "@mui/material";
import Button from "@mui/material/Button";

interface SidePost {
    no: number,
    title: string
}

interface State {
    post: PostInterface,
    prevPost: SidePost,
    nextPost: SidePost,
}

Quill.register('modules/imageDropAndPaste', QuillImageDropAndPaste);


let isWin = false;
let isDot = false;
export default function ReplyEditor(props: {
    style: any;
    contents: string, state: any, setState: any
}) {
    const QuillRef = useRef<ReactQuill>();
    const [open, setOpen] = useState(false);

    function handleChange(e: any) {
        props.setState({
            ...props.state,
            contents: e,
        });
    }

    const handler: any = common.imageHandler(QuillRef);
    // @ts-ignore
    let _this: any = this;

    const dndImageHandler = (dataUrl: any, type: any, imageData: any, callback: any) => {
        // imageData.minify({
        // 	maxWidth: 320,
        // 	maxHeight: 320,
        // 	quality: 0.7,
        // }).then((miniImageData: any) => {
        // 	console.log(typeof dataUrl);
        // 	console.log(typeof miniImageData);
        // 	console.log(typeof miniImageData.dataUrl);
        // 	console.log('Calling...');
        // 	// callback.call(this, miniImageData.dataUrl);
        // 	callback.call(_this, miniImageData.dataUrl);
        // });
    };

    const modules = useMemo(
        () => ({
            toolbar: {
                container: [
                    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                    [{size: ['small', false, 'large', 'huge']}, {color: []}],
                    [
                        {list: 'ordered'},
                        {list: 'bullet'},
                        {indent: '-1'},
                        {indent: '+1'},
                        {align: []},
                    ],
                    ['image', 'video'],
                ],
                handlers: {
                    image: handler,
                },
            },
            ImageResize: {
                parchment: Quill.import('parchment'),
            },
            imageDropAndPaste: {handler: dndImageHandler},
        }),
        [],
    );


    return (
        <>
            <ReactQuill
                style={props.style}
                ref={(element) => {
                    if (element !== null) {
                        QuillRef.current = element;
                    }
                }}
                modules={modules}
                value={props.contents}
                onChange={(e) => handleChange(e)}
                theme="bubble"
                placeholder="내용을 입력해주세요."
            />
        </>

    );
}


